import { uuidv7 } from "uuidv7"

import type { DatagramErrorBuf, MessageIdBuf, WebsocketIdBuf } from "~/classes/generated/datagram"

import { RequestIdBuf } from "~/classes/generated/datagram"

import { addUuidToBuf, parseUuidBuf } from "./id"

export function parseVector<T>(accessor: (n: number) => T | null, length: number) {
  const vec = []
  for (let i = 0; i < length; i++) {
    const item = accessor(i)
    if (item === null)
      throw new Error("Invalid vector length")
    vec.push(accessor(i))
  }
  return vec as NonNullable<T>[]
}

function _parseIdLike(buf: RequestIdBuf | MessageIdBuf | WebsocketIdBuf) {
  const key = parseUuidBuf(buf.id()!)
  return key.toString()
}

export function parseRequestId(buf: RequestIdBuf) {
  return _parseIdLike(buf)
}

export function parseMessageId(buf: MessageIdBuf) {
  return _parseIdLike(buf)
}

export function parseSenderId(buf: WebsocketIdBuf) {
  return _parseIdLike(buf)
}

export function addRequestIdToBuf(fbb: DatagramBufferBuilder, requestId?: string) {
  const uuid = requestId ?? uuidv7()
  const id = addUuidToBuf(fbb, uuid)
  return RequestIdBuf.createRequestIdBuf(fbb, id)
}

export function parseDatagramError(DatagramErrorBuf: DatagramErrorBuf): DatagramError {
  const type = DatagramErrorBuf.type()
  const details = DatagramErrorBuf.details()
  if (details === null)
    throw new Error("No error details provided")
  return { type, details }
}
